/**
 * Development Configuration
 *
 * Toggle between mock data and real API calls during development.
 * Set useMockData to false when backend is ready.
 */

export const DEV_CONFIG = {
  // Use mock data instead of real API calls
  useMockData: false,

  // Simulate API delay (milliseconds)
  mockDelay: 500,

  // Show debug information in console
  debug: true,

  // Mock wallet connection (skip real wallet popup)
  mockWalletConnection: false, // Set to false to use real wallets

  // Auto-login with mock user on page load
  autoLogin: false,

  // Log API calls and responses
  logAPICalls: true
}

/**
 * Helper function to simulate async API delay
 */
export async function simulateDelay(customDelay = null) {
  if (!DEV_CONFIG.useMockData) return

  const delay = customDelay !== null ? customDelay : DEV_CONFIG.mockDelay
  await new Promise(resolve => setTimeout(resolve, delay))
}

/**
 * Helper function for development logging
 */
export function devLog(message, data = null) {
  if (!DEV_CONFIG.debug) return

  const timestamp = new Date().toISOString()
  console.log(`[DEV ${timestamp}]`, message, data || '')
}
